// extracted by mini-css-extract-plugin
export var auto = "_3h-1";
export var spinner = "_3h-0";